import React from 'react';

const Education = () => {
  return (
    <section className="education" id="education">
      <header className="text-center">
        <h2><span className="index">03</span> EDUCATION</h2>
      </header>
      <main className="container p-5 p-sm-0">
        <div className="item row">
          <div className="col-md-6 d-none d-md-block"></div>
          <div className="border-bullet section col-md-6">
            <p className="mb-0">2014 - 2019</p>
            <h3 className="h4">Bachelor of Engineering</h3>
            <br />
            <h6>Faculty of Electronic Engineering</h6>
                Computer Science & Engineering
            </div>
        </div>
        <div className="item row">
          <div className="section text-md-right col-md-6">
            <p className="mb-0">JUL 2018 - AUG 2018</p>
            <h3 className="h4">Internship</h3>
            <br />
            <h6>Information Technology Institute (ITI)</h6>
                Front-End Web Development
            </div>
          <div className="border-bullet col-md-6 d-none d-md-block"></div>
        </div>
      </main>
    </section>
  );
}

export default Education;
